module.exports = __webpack_public_path__ + "static/media/event.d9783b98.jpg";